var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLego(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_13061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9933 15.3877L39.1895 11.4821C38.747 8.44271 35.3008 6.14771 30.9883 6.14771C26.3627 6.14771 22.7383 8.78396 22.7383 12.1477C22.7395 12.88 22.9122 13.6017 23.2427 14.2552L21.4802 15.1365C20.0308 14.2102 18.1164 13.6477 15.9883 13.6477C11.3627 13.6477 7.73829 16.284 7.73829 19.6477C7.73949 20.38 7.91224 21.1017 8.24266 21.7552L2.98141 24.3802C2.60703 24.5675 2.29233 24.8556 2.07272 25.212C1.85311 25.5684 1.73729 25.9791 1.73829 26.3977V36.8977C1.73834 37.3154 1.85465 37.7248 2.0742 38.0801C2.29376 38.4355 2.60788 38.7227 2.98141 38.9096L14.9814 44.9096C15.294 45.066 15.6387 45.1474 15.9883 45.1474C16.3378 45.1474 16.6826 45.066 16.9952 44.9096L46.9952 29.9096C47.3687 29.7227 47.6828 29.4355 47.9024 29.0801C48.1219 28.7248 48.2382 28.3154 48.2383 27.8977V17.3977C48.2377 16.9801 48.121 16.571 47.9011 16.216C47.6812 15.861 47.3669 15.5742 46.9933 15.3877ZM15.9883 29.8815L9.01891 26.3977L11.9833 24.9165C13.2606 25.4093 14.6192 25.6573 15.9883 25.6477C20.6139 25.6477 24.2383 23.0115 24.2383 19.6477C24.2371 19.3723 24.212 19.0975 24.1633 18.8265L26.9758 17.4165C28.2554 17.9102 29.6167 18.1583 30.9883 18.1477C33.7483 18.1477 36.1502 17.2102 37.6389 15.7383L40.9577 17.3977L15.9883 29.8815ZM30.9883 10.6477C33.4089 10.6477 34.7383 11.7727 34.7383 12.1477C34.7383 12.5227 33.4089 13.6477 30.9883 13.6477C28.5677 13.6477 27.2383 12.5227 27.2383 12.1477C27.2383 11.7727 28.5677 10.6477 30.9883 10.6477ZM15.9883 18.1477C18.4089 18.1477 19.7383 19.2727 19.7383 19.6477C19.7383 20.0227 18.4089 21.1477 15.9883 21.1477C13.5677 21.1477 12.2383 20.0227 12.2383 19.6477C12.2383 19.2727 13.5677 18.1477 15.9883 18.1477ZM6.23829 30.039L13.7383 33.789V39.2565L6.23829 35.5065V30.039ZM18.2383 39.2565V33.789L43.7383 21.039V26.5065L18.2383 39.2565Z",
    fill: "url(#paint0_linear_1560_13061)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1560_13061",
    x1: 24.9883,
    y1: 6.14771,
    x2: 24.9883,
    y2: 45.1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_13061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.988281 0.897705)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLego);
export default __webpack_public_path__ + "static/media/Lego.c43802b5b734e1a57ef4f86368fdbe47.svg";
export { ForwardRef as ReactComponent };